export const loadCourseDetailAction = "Load Course Detail Action";
